import React from "react";
import DashboardCard from "./DashboardCard";
import CustomNoData from "../../../components/CustomNoData";

const TopUsersTable = ({ users = [] }) => {
  return (
    <DashboardCard className="p-3">
      <header className="mb-2 flex items-center justify-between gap-3">
        <h2 className="text-base font-bold text-customInk dark:text-customHeading">Top Users</h2>
        {/* <div className="flex overflow-hidden rounded border border-slate-200 text-[11px] dark:border-customBorder">
          {["Top Winners", "Top Losers", "Highest Turnover"].map((tab) => (
            <button
              type="button"
              key={tab}
              className={`h-7 px-3 font-semibold ${
                tab === "Top Winners"
                  ? "bg-customAccentBlue text-white"
                  : "bg-white text-customPrimaryText dark:bg-customSurface dark:text-customMuted"
              }`}
            >
              {tab}
            </button>
          ))}
        </div> */}
      </header>
      {users.length === 0 ? (
        <div className="h-[190px]">
          <CustomNoData title="No top users" description="No top user data found for the selected date range." />
        </div>
      ) : (
        <table className="min-w-full text-xs">
          <thead className="border-b border-slate-200 text-[11px] text-customPrimaryText dark:border-customBorder dark:text-customMuted">
            <tr>
              <th className="w-8 py-2 text-left">#</th>
              <th className="py-2 text-left">User</th>
              <th className="py-2 text-right">Bet Amount</th>
              <th className="py-2 text-right">Net Win</th>
            </tr>
          </thead>
          <tbody>
            {users.map((user) => (
              <tr key={user.user} className="border-b border-slate-100 last:border-0 dark:border-customBorder/70">
                <td className="py-2 font-semibold">{user.rank}</td>
                <td className="py-2">
                  <div className="flex items-center gap-2">
                    <span className={`grid h-7 w-7 place-items-center rounded-full text-xs font-bold text-white ${user.color}`}>
                      {user.initials}
                    </span>
                    <span>{user.name} <span className="text-customSecondaryText">({user.user})</span></span>
                  </div>
                </td>
                <td className="py-2 text-right">{user.amount}</td>
                <td className="py-2 text-right font-semibold text-customFontLightGreen dark:text-customDarkGreen">{user.net}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </DashboardCard>
  );
};

export default TopUsersTable;
